// extracted by mini-css-extract-plugin
export default {"container":"InvoiceStatusTimeline_container__o7n0Z","status":"InvoiceStatusTimeline_status__KP-LF","dot":"InvoiceStatusTimeline_dot__t5vNw"};